import { t } from "i18next"; 
import useToast from "./useToast";
import useGetData from "./ReactQuery/useGetData";

interface UsePrintPdfProps {
  endPoint?: string;
  enabled?: boolean;
  file?: any;
  id?: number | string;
}

const usePrintPdf = ({
  endPoint,
  enabled = true,
  file,
  id,
}: UsePrintPdfProps) => {
  const { showToast } = useToast();

  const {
    data,
    error: GetReportError,
    isLoading,
    isSuccess,
  } = useGetData<any>(
    endPoint ?? "",
    {
      enabled: enabled && !!endPoint,
      staleTime:0
    },
    id,
  );

  const fileData = file ?? data;

  const handleExportPDF = async () => {
    try {
      const byteCharacters = atob(fileData?.Data?.FileContents);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileData?.Data?.FileDownloadName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      showToast(
        GetReportError?.message ?? t("an_error_occurred_please_try_again"),
        "error",
      );
    }
  };

  return {
    data,
    isLoading,
    isSuccess,
    handleExportPDF,
    error: GetReportError,
  };
};

export default usePrintPdf;
